import { default as AgentInfoVerification } from './components/AgentInfoVerification';

export default {
  path: '/',
  name: 'AgentInfoVerification',
  childRoutes: [
    { path: '/', name: 'AgentInfoVerification', component: AgentInfoVerification, isIndex: true }
  ],
};



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/route.js